var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("Click here to compare prices from over "+_vm._s(_vm.numberOfProviders)+" other providers to help you find a great deal!")])}
var staticRenderFns = []

export { render, staticRenderFns }